<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="120px" v-model="queryParams">
                <el-form-item label="平台订单号">
                    <el-input size="small" v-model="queryParams.ordersn" placeholder="平台订单号,如shopee或者lazada" style="width: 240px" />
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker size="small" type="daterange" @change="cbtime" v-model="others.btime" start-placeholder="开始时间" end-placeholder="开始时间" value-format="yyyy-MM-dd" style="width: 240px"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <Table :loading="loading" :columns="columns" :data="gatherRecords" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
    </div>
</template>
<script>
export default {
    name: 'GatherRecord',
    data() {
        return {
            loading: false,

            modalLoading: false,
            queryParams: {

            },
            others: {

            },
            gatherRecord: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            gatherRecords: [

            ],
            rules: {},
            columns: [{
                    title: '系统订单号',
                    key: 'orderid',
                    width: 180,
                    align: 'center'
                }, {
                    title: '平台单号',
                    key: 'ordersn',
                    width: 180,
                    align: 'center'
                }, {
                    title: '时间',
                    key: 'createTime',
                    width: 180,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2datetime(params.row.createTime))
                        ]);
                    }
                }, {
                    title: '地区',
                    key: 'weight',
                    width: 150,
                    align: 'center'
                }, {
                    title: '重量/体积',
                    key: 'weight',
                    width: 150,
                    align: 'center'
                }, {
                    title: '费用',
                    key: 'fee',
                    width: 150,
                    align: 'center'
                }, {
                    title: '操作人',
                    key: 'sysName',
                    width: 130,
                    align: 'center'
                }

            ]
        };
    },
    mounted: function() {
        this.getList();

    },
    methods: {
        cbtime: function(value) {
            if (value) {
                this.queryParams.btime = value[0];
                this.queryParams.etime = value[1];
            } else {
                this.queryParams.btime = "";
                this.queryParams.etime = "";
            }
        },

        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/gatherrecord/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.gatherRecords = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        delete: function(id) {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.$http.post("/ware/gatherrecord/doDelete.action", { id: id }).then(response => {
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {

                    });
                },
                onCancel: function() {

                }
            });
        }

    }
}
</script>
<style scoped>
</style>